import { PagingInfo } from "@/core/types/contentTypes";
import { IndexedObjectsByString } from "@/core/types/storeTypes";
import { DataRequestSign } from "@/core/types/dataRequestsTypes";

/**
 * returns paging info for provided sign and data
 *
 * @TODO consider if possible to rework to hooks similar to ./hooks/contentFilters
 * */

const getPagingInfo =
  (sign: DataRequestSign | null, pagingInfo: IndexedObjectsByString<PagingInfo> | undefined) =>
  (): PagingInfo | null => {
    if (sign && pagingInfo && pagingInfo[JSON.stringify(sign)]) {
      return pagingInfo[JSON.stringify(sign)];
    }
    return null;
  };

export default getPagingInfo;
